import React, { Component } from "react";
import Header from "../../components/Header";
import Footer from "../../components/footer/footer.index";
import "./disclaimer.style.css";

class Disclaimer extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <>
        <Header />
        <footer className="mainfooter">
          <Footer />
        </footer>
      </>
    );
  }
}

export default Disclaimer;
